// Import of the module
import { parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Factor type enum mapping
const factorTypeMap: Record<number, string> = {
  0: "Market",
  1: "Low Beta",
  2: "Size",
  3: "Value",
  4: "Momentum",
  5: "Quality",
  6: "Risk Free",
  7: "Alpha",
  8: "Equity",
  9: "Sovereign",
  10: "Investment Grade",
  11: "High Yield",
  12: "Mortgage",
  13: "Gold",
  14: "Oil",
};

// Type of the fields in the table
export type Factor = {
  id: number;
  group_name: string | null;
  factor_type: number;
  tag: string | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns
export const factor_columns: ColumnDef<Factor>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "group_name",
    header: "Group Name",
    cell: ({ row }) => row.getValue("group_name") ?? "",
  },
  {
    accessorKey: "factor_type",
    header: "Factor Type",
    cell: ({ row }) => {
      const factorTypeValue = row.getValue<number>("factor_type");
      return factorTypeMap[factorTypeValue] || String(factorTypeValue);
    },
  },
  {
    accessorKey: "tag",
    header: "Tag",
    cell: ({ row }) => row.getValue("tag") ?? "",
  },

  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue<string>("created_at")),
  },
];
